var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as MuiIcons from '@mui/icons-material';
function MuiIcon(_a) {
    var iconName = _a.iconName, iconColor = _a.iconColor, props = __rest(_a, ["iconName", "iconColor"]);
    var cleanIconName = iconName.trim().replace(/Icon$/i, '');
    var IconComponent = MuiIcons[cleanIconName];
    if (!IconComponent) {
        return _jsx(MuiIcons.HelpOutline, __assign({ sx: { color: iconColor } }, props));
    }
    return (_jsx(IconComponent, __assign({}, props, { sx: __assign({ color: iconColor }, props.sx) })));
}
export default MuiIcon;
